import { color, important } from 'csx'
import { FC } from 'react'
import { classes, stylesheet } from 'typestyle'

import { Box } from '../../../components/box/box.component'
import { Button } from '../../../components/button'
import { Circle } from '../../../components/circle'
import { StyleClass } from '../../../components/style-class'
import { Text } from '../../../components/text/text.component'

import { paddingLeftOuter } from '../../../styles/default/padding'
import { ml4 } from '../../../styles/styleset/margin/ml4'
import { mr12 } from '../../../styles/styleset/margin/mr12'
import { pr12 } from '../../../styles/styleset/padding/pr12'
import { HelpButton } from '../../components/help-button'

export const NavItem: FC<{
  label?: string
  parentLabel?: string
  icon?: any
  onClick?: any
  highlight?: boolean
  semiHighlight?: boolean
  className?: string
  padForLogo?: boolean
  padForParent?: boolean
  disableHighlight?: boolean
  position?: string
  help?: string
  isButton?: boolean
  indent?: number
}> = props => {
  const {
    icon,
    label,
    parentLabel,
    highlight,
    semiHighlight,
    className,
    padForLogo,
    disableHighlight,
    help,
    indent,
  } = props

  const STYLES = _STYLES.setProps({
    disableHighlight,
    highlight,
    semiHighlight,
    padForLogo,
    icon,
    indent,
  })

  return (
    <Box
      baseline="none"
      className={classes(
        'aeki-nav-item',
        paddingLeftOuter,
        STYLES.container,
        STYLES.base,
        className,
      )}
      relative
      fullWidth
    >
      {!props.isButton && (
        <Box
          className={classes(mr12)}
          baseline="none"
          flex
          alignCenterX
          style={{ marginLeft: (indent || 0) * 8 }}
        >
          <Circle className={STYLES.circle} size="xs">
            <span className={classes('material-icons-two-tone', STYLES.icon)}>{icon}</span>
          </Circle>
        </Box>
      )}
      {props.isButton ? (
        <Box row fullWidth>
          <Box className={pr12} row fullWidth style={{ marginLeft: (indent || 0) * 8 }}>
            <Button
              icon={<span className={classes('material-icons-two-tone', STYLES.icon)}>{icon}</span>}
              label={label}
              size="sm"
              baseline="background"
              square
            />
          </Box>
        </Box>
      ) : (
        <Box baseline="none" row>
          {parentLabel && (
            <Text
              className={STYLES.textParentLabel}
              baseline="surface"
              size="xs"
              shrink
              light
              disableMediaQuery
            >
              {parentLabel}
            </Text>
          )}
          <Text className={STYLES.textLabel} baseline="surface" size="sm" disableMediaQuery shrink>
            {label}
          </Text>
        </Box>
      )}
      {help && <HelpButton postId={help} className={ml4} baseline="none" />}
      {highlight && (
        <div
          className={STYLES.highlight}
          style={{ position: 'absolute', width: 3, height: '100%', right: 0 }}
        />
      )}
    </Box>
  )
}

const _STYLES = new StyleClass<any, any>((props: any, theme: any) => {
  const { highlight, semiHighlight, disableHighlight, padForLogo, icon, indent = 0 } = props
  let background = ''

  const lightenAnchor = 0.08
  const dark = color(theme?.layout?.navigation?.item?.circle?.dark).lighten(
    lightenAnchor * (indent / 3),
  )
  const medium = color(theme?.layout?.navigation?.item?.circle?.medium).lighten(
    lightenAnchor * (indent / 3),
  )

  if (semiHighlight) {
    background = theme?.layout?.navigation?.item?.base?.dark
  }

  if (highlight) {
    background = theme?.layout?.navigation?.item?.base?.dark
  }

  return {
    ...stylesheet({
      base: {
        // minWidth: '246px',
        background,
        $nest: {
          '.circle1': {
            position: 'absolute',
            zIndex: 0,
            top: highlight ? 0 : -2,
            left: highlight ? 0 : -2,
            transition: '0.2s ease',
          },
          '.circle2': {
            position: 'absolute',
            zIndex: 0,
            top: highlight ? 0 : 2,
            left: highlight ? 0 : 2,
            transition: '0.2s ease',
          },
          '&:hover': {
            color: 'black !important',
            fontWeight: 500,
            background: !disableHighlight
              ? highlight || semiHighlight
                ? theme?.layout?.navigation?.item?.base?.medium
                : theme?.layout?.navigation?.item?.base?.light
              : '',
            $nest: {
              '.circle1': {
                top: 0,
                left: 0,
              },
              '.circle2': {
                top: 0,
                left: 0,
              },
            },
          },
          '&:after': {
            content: 'hello',
            position: 'absolute',
            width: 4,
            height: 80,
            background: 'red',
          },
        },
      },
      circle: {
        background: highlight || semiHighlight ? dark.toHexString() : medium.toHexString(),
        width: 26,
        height: 26,
      },
      container: {
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
        float: 'left',
        height: 36,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        $nest: {
          '*': {
            cursor: 'pointer',
          },
        },
      },
      containerHighlighted: {
        background: theme.baselines.background.color.medium,
      },
      icon: (() => {
        switch (icon) {
          case 'arrow_back':
            return {
              fontSize: important('15px'),
              width: 15,
              height: 15,
              marginLeft: 1,
              color: 'white',
            }
        }

        return { fontSize: important('15px'), width: 15, height: 15, marginLeft: 0, marginTop: 0 }
      })(),
      textParentLabel: {
        color: theme?.layout?.navigation?.item?.contrast?.dark,
      },
      textLabel: {
        color: theme?.layout?.navigation?.item?.contrast?.medium,
      },
      highlight: {
        background: theme?.baselines.primary.color.dark,
      },
    }),
  }
})
